module.exports = {"630123100":"城关镇","630123101":"大华镇","630123200":"东峡乡","630123201":"日月乡","630123202":"和平乡","630123203":"波航乡","630123204":"申中乡","630123205":"巴燕乡","630123206":"寺寨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/630123.json
// module id = 2985
// module chunks = 0